import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case06.introduction-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  description: {
    id: `${PREFIX}.description`,
  },
  bioNote: {
    id: `${PREFIX}.bio-note`,
  },
  bioNielsTitle: {
    id: `${PREFIX}.bio.niels.title`,
  },
  bioNielsDescription: {
    id: `${PREFIX}.bio.niels.description`,
  },
});
